import React from "react";
import { useAppSelector } from "../store";
import { ESliceAuth } from "../../store/slices/authSlice";


export const useCurrentUser = () => {
    return useAppSelector((state) => state[ESliceAuth.AuthInfo]);
};


